var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"con"},[_c('div',{staticClass:"txt",domProps:{"innerHTML":_vm._s(_vm.info.content)}},[_c('p',[_vm._v("\n     一则好的文案，几乎决定了广告营销必将走向成功之路。其实，广告文案是有规则可循的。广告文案大师约瑟夫·休格曼曾说过这样一句话：复杂的产品要简单说明，简单的产品要复杂说明。今天，菲力克影视同大家简单分享一些关于这两句话的理解。为什么是对立的层面？这其实取决于消费者对于产品的认知和心理感触。\n   ")])])])}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-592bbe64","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/detaile.vue
// module id = null
// module chunks = 